import React from 'react';
import cn from 'classnames';
import Color from 'swag-client-common/components/ui/color';
import Radio from 'swag-client-common/components/ui/radio-button';
import { SuperSpeedIcon } from 'swag-client-common/components/partials/super-speed-icon';
import css from '../content.scss';
import { ProductInfoBlock } from '../components/product-info-block';
import AddonInfoBlock from './addon-info-block';
export const CardItem = ({
  isAddonFlow,
  itemId,
  variant,
  sizes,
  quantitiesItem,
  isSelected,
  isLimitedEdition,
  productName,
  isLE,
  isSuperSpeed,
  logo,
  totalQuantityInCart,
  quantityPerBox,
  itemPriceValue,
  isQtyError,
  productIsAlwaysInStock,
  errorText,
  onSelectionClick,
  onChangeHowManyInEachBox,
  onChangeHowManyAddonInEachBox,
  onQuantityPerSizeChange,
  totalCount,
  totalSizesQuantity,
  onQuantityInCart,
  remainingQuantityInCart
}) => {
  const handleSelectItem = e => {
    const ignoreSelect = e.target.dataset.ignoreSelection;
    if (ignoreSelect) {
      return;
    }
    const isInput = e.target.nodeName === 'INPUT';
    const isPerSizeInput = Boolean(e.target.dataset.perSizeInput);
    if (isSelected && isInput) {
      return;
    }
    onSelectionClick({
      prefillQuantityPerBox: !isInput || isPerSizeInput,
      itemId,
      variantIndex: variant.variantIndex,
      isSelected: !isSelected
    });
  };
  return /*#__PURE__*/React.createElement("li", {
    "data-item": itemId,
    onClick: handleSelectItem,
    className: cn(css.cardItem, {
      [css.addonCardItem]: isAddonFlow,
      [css.isSelected]: isSelected
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: css.imgWrapper
  }, /*#__PURE__*/React.createElement(Radio, {
    isResponsive: true,
    className: css.radioButton,
    onClick: () => {
      onSelectionClick({
        prefillQuantityPerBox: true,
        itemId,
        variantIndex: variant.variantIndex,
        isSelected: !isSelected
      });
    },
    checked: isSelected
  }), /*#__PURE__*/React.createElement("img", {
    src: logo,
    alt: productName
  }), isLE && /*#__PURE__*/React.createElement("div", {
    className: css.le
  }, "Limited Edition"), !isAddonFlow && variant.color && /*#__PURE__*/React.createElement(Color, {
    className: cn(css.colorCircle, {
      [css.isLECircle]: isLE
    }),
    badgeClassName: css.badgeClassName,
    name: variant.name,
    key: variant.color,
    color: variant.color,
    tooltipText: variant.name,
    isActionable: false,
    showTooltip: true
  }), isLimitedEdition && /*#__PURE__*/React.createElement("div", {
    className: css.limitedEditionWidget
  }, "Limited Edition"), isSuperSpeed && /*#__PURE__*/React.createElement("div", {
    className: css.superSpeedIcon
  }, /*#__PURE__*/React.createElement(SuperSpeedIcon, null))), isAddonFlow ? /*#__PURE__*/React.createElement(AddonInfoBlock, {
    productName: productName,
    totalCount: totalCount,
    quantityPerBox: quantityPerBox,
    itemPriceValue: itemPriceValue,
    handleSelectItem: handleSelectItem,
    onChangeHowManyAddonInEachBox: quantityPerBox => onChangeHowManyAddonInEachBox({
      quantityPerBox,
      itemId
    })
  }) : /*#__PURE__*/React.createElement(ProductInfoBlock, {
    isSelected: isSelected,
    totalQuantityInCart: totalQuantityInCart,
    remainingQuantityInCart: remainingQuantityInCart,
    onQuantityInCart: onQuantityInCart,
    totalCount: totalCount,
    totalSizesQuantity: totalSizesQuantity,
    handleSelectItem: handleSelectItem,
    onChangeHowManyInEachBox: quantityPerBox => onChangeHowManyInEachBox({
      quantityPerBox,
      itemId,
      variantIndex: variant.variantIndex
    }),
    onQuantityPerSizeChange: quantities => {
      onQuantityPerSizeChange({
        quantities,
        itemId,
        variantIndex: variant.variantIndex
      });
    },
    errorText: errorText,
    quantityPerBox: quantityPerBox,
    productIsAlwaysInStock: productIsAlwaysInStock,
    itemPriceValue: itemPriceValue,
    sizes: sizes,
    quantitiesItem: quantitiesItem,
    isQtyError: isQtyError,
    productName: productName,
    variant: variant
  }));
};